var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7279 12.7279C15.6396 9.81623 15.6396 5.09545 12.7279 2.18377C9.81623 -0.727922 5.09546 -0.727922 2.18377 2.18377C-0.727922 5.09545 -0.727922 9.81623 2.18377 12.7279L7.45584 18L12.7279 12.7279ZM7.45552 10.9284C9.37338 10.9284 10.9281 9.37364 10.9281 7.45578C10.9281 5.53793 9.37338 3.9832 7.45552 3.9832C5.53767 3.9832 3.98294 5.53793 3.98294 7.45578C3.98294 9.37364 5.53767 10.9284 7.45552 10.9284Z",
    fill: "#8C8C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGreyIcon);
export default __webpack_public_path__ + "static/media/map-grey-icon.9deabccb087ea42cdc81fb4232400562.svg";
export { ForwardRef as ReactComponent };